import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { childParser } from "containers/utilities"
import { MapLocationContainer, Column, ColumnGroup, HeadingBlock } from "containers"
import { WysiwygContent } from "components"

const SelectDealer = ({
  mapBlockProps,
  preHeading = "",
  heading = "",
  description = "",
  components = []
}) => (
  <div
    style={{
      display: "flex",
      flex: "1 1 100%",
      flexDirection: "column"
    }}>
    {childParser({ components })}
    <ColumnGroup>
      <Column textAlign={"center"}>
        <HeadingBlock margin textAlign={"center"} preHeading={preHeading} value={heading} />
        {description && (
          <WysiwygContent style={{ maxWidth: "45em", margin: "0 auto" }} xmlString={description} />
        )}
      </Column>
    </ColumnGroup>
    <MapLocationContainer
      searchType="search"
      {...mapBlockProps}
      flexSizing
      scrollToMain={true}
      hideMapInCompact
      hideWhenNoLocation
      heading={null}
      displaySearchTop
      initialSelectedFilters={{
        sales: true,
        service: false,
        parts: false
      }}
      disableFilters
      mapFixedHeight
      mapFixHeightStyle={{
        height: "60vh",
        minHeight: "500px"
      }} />
  </div>
)

SelectDealer.propTypes = {
  preHeading: PropTypes.string,
  mapBlockProps: PropTypes.object,
  onDealerChange: PropTypes.func,
  heading: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  components: PropTypes.array
}

export default Radium(SelectDealer)



// WEBPACK FOOTER //
// ./src/containers/outlet-store/select-dealer.jsx